import { createContext } from 'react';
import type { NotesContextValue } from '../../types';

export const NotesContext = createContext<NotesContextValue | null>(null);
